{
  "de": {
    "editor_ziggu": {
      "actions": {
        "apply": "Anwenden",
        "cancel": "Abbrechen",
        "link": "Link",
        "showLess": "Weniger anzeigen",
        "showMore": "Mehr anzeigen"
      },
      "labels": {
        "blue": "Blau",
        "green": "Grün",
        "link_text": "Linktext",
        "orange": "Orange",
        "pink": "Pink",
        "purple": "Lila",
        "red": "Rot",
        "remove_highlight": "Hervorhebung entfernen",
        "yellow": "Gelb"
      },
      "placeholders": {
        "content": "Beginnen Sie mit der Eingabe..",
        "link": "Link eingeben oder einfügen"
      }
    }
  }
}
